<script>
import RubricForm from "@/components/rubrics/rubric_form.vue";

export default {
  name: "RubricPreviewTab",
  components: {
    RubricForm,
  },
  props: {
    rubric: {
      type: Object,
      default: null,
    },
  },
};
</script>

<template>
  <div class="rubric-preview-tab">
    <rubric-form
      v-if="rubric"
      :rubric="rubric"
      :editing="false"
      :hide-actions="true"
      preview-mode
    />
    <div v-else class="preview-placeholder">
      <p class="text-muted">{{ $t("rubrics.noRubricPreview") }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.preview-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}
</style>
